import React, { createContext, useContext, useState } from 'react';
import { Language, Strings, strings } from './strings';

interface LanguageContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Strings;
}

const LanguageContext = createContext<LanguageContextValue>({
  language: 'en',
  setLanguage: () => {},
  t: strings.en,
});

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(() => {
    const saved = localStorage.getItem('language') as Language;
    return saved && saved in strings ? saved : 'en';
  });

  const setLanguage = (lang: Language) => {
    localStorage.setItem('language', lang);
    document.documentElement.lang = lang;
    setLanguageState(lang);
  };

  document.documentElement.lang = language;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t: strings[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
